import type { Player } from '../types/player';
import { nflSeasonContext } from './nflSeason';

export function homeBoardRows(
  players: Player[],
  position: string,
  limit: number = 10
): Player[] {
  const filtered = position === 'All'
    ? players
    : players.filter((player) => player.position === position);
  return filtered.slice(0, limit);
}

export function deskSeasonLine(now: Date = new Date()): string {
  const month = now.getMonth();
  const { lastCompleted, projectionSeason } = nflSeasonContext(now);

  if (month >= 7 && month <= 8) {
    return `The ${projectionSeason} board is up. Preseason is for locking ranks before week 1.`;
  }
  if (month >= 9 || month <= 0) {
    return `In-season ranks for ${projectionSeason}. Flip the format and the board moves with it.`;
  }
  return `Offseason board, built from ${lastCompleted}. Good time to mock and shop.`;
}

export function rosterIdsFromMetadata(
  stored: unknown,
  activeId: unknown
): string[] {
  if (!Array.isArray(stored)) return [];
  const rosters = stored.filter((row): row is { id?: string; players?: unknown } => (
    Boolean(row) && typeof row === 'object'
  ));
  const active = (typeof activeId === 'string' && rosters.find((row) => row.id === activeId))
    || rosters[0];
  if (!active || !Array.isArray(active.players)) return [];
  return active.players
    .filter((id): id is string | number => typeof id === 'string' || typeof id === 'number')
    .map(String);
}

export function peekRoster(board: Player[], ids: string[], limit: number = 8): Player[] {
  if (ids.length === 0 || board.length === 0) return [];
  const byId = new Map(board.map((player) => [String(player.id), player]));
  return ids
    .map((id) => byId.get(id))
    .filter((player): player is Player => Boolean(player))
    .slice(0, limit);
}
